const getStreetViewAvailability = async (coords) => {
    if (!coords) {
        return false;
    }
    const maps = window.google?.maps;
    if (!maps || !maps.StreetViewService) {
        return false;
    }
    const sv = new maps.StreetViewService();
    try {
        const result = await new Promise(resolve => {
            sv.getPanorama({ location: coords, radius: 50 }, (_, status) => {
                resolve(status === maps.StreetViewStatus.OK);
            });
        });
        return result;
    }
    catch {
        return false;
    }
};
export default getStreetViewAvailability;
//# sourceMappingURL=getStreetViewAvailability.js.map